import {v4 as uuid } from 'uuid';
import isEmpty from 'lodash/isEmpty';

function setSubscribersFields (p, options = null) {
    const fields = Object.keys(p);
    this.updateTouched(fields);
    this.updateCursorTarget(options);
    this.subscribersFields = {
        ...this.subscribersFields,
        ...p,
    };
    this.captureFields();
    this.observed.subscribersFields = uuid();
}

export function updateCursorTarget (options) {
    if (!isEmpty(options)) {
        const cursor = this.getSelectionRange(options);
        this.cursorPositions[options.field] = {
            start: cursor.start,
            end: cursor.end,
        };
        this.cursorTarget = {
            element: cursor.element,
            field: options.field,
            selector: options.selector,
        }
        this.observed.cursorPositions = uuid();
    } else {
        this.cursorTarget = {};
        this.cursorPositions = {};
    }
}

export function getSelectionRange (options) {
    const selector = options.selector;
    const el = document.querySelector(selector);
    if (el) {
        return {
            start: el.selectionStart,
            end: el.selectionEnd,
            element: el,
        };
    }
    return {
        start: 0,
        end: 0,
        element: null,
    }
}

export default setSubscribersFields;
